import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { Results } from '../controls/advanced-gridview/models/results-T';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { FolderState } from '../models/folder-state';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class FoldersStatesService extends CrudService {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<FolderState>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/foldersStates`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<FolderState>(FolderState, x);
                return res;
            })
        );
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): Observable<Blob> {
        const headers = this.getExportHeader(context, filters, generalFilters, sortInfos);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/foldersStates/export`, { headers: headers, responseType: 'blob' }).pipe(
            map((res: any) => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                return blob;
            })
        );
    }

    update(folderStateId: number, folderState: FolderState): Observable<FolderState> {
        // Appel de la Web Api
        return this.http
            .put<FolderState>(this.baseUrl + `/api/organizations/${this.organizationId}/foldersStates/${folderStateId}`, folderState, this.getDefaultHttpOptions())
            .pipe(
                map((x) => {
                    return FolderState.from(x);
                })
            );
    }

    delete(folderStateId: number): Observable<boolean> {
        // Appel de la Web Api
        return this.http.delete<FolderState>(this.baseUrl + `/api/organizations/${this.organizationId}/foldersStates/${folderStateId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return true;
            })
        );
    }

    add(folderState: FolderState): Observable<FolderState> {
        // Appel de la Web Api
        return this.http.post<FolderState>(this.baseUrl + `/api/organizations/${this.organizationId}/foldersStates`, folderState, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return FolderState.from(x);
            })
        );
    }

    get(folderStateId: number): Observable<FolderState> {
        // Appel de la Web Api
        return this.http.get<FolderState>(this.baseUrl + `/api/organizations/${this.organizationId}/foldersStates/${folderStateId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return FolderState.from(x);
            })
        );
    }

    applyOrderChanges(folderstates: FolderState[]) {
        // Appel de la Web Api
        return this.http
            .patch<FolderState[]>(this.baseUrl + `/api/organizations/${this.organizationId}/foldersStates/`, folderstates, this.getDefaultHttpOptions())
            .pipe(map((x) => {}));
    }
}
